var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from "react-toastify";
import { getLogsRequest } from "../../../../api/api";
import { WPQTTypes } from "../../../../types/enums";
import { CommentsAndLogsTabContent, TabContentItem, } from "../CommentsAndLogsTabContent";
function LogsTabContent({ taskId }) {
    const fetchLogs = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getLogsRequest(taskId, WPQTTypes.Task);
            return response.data;
        }
        catch (error) {
            console.error(error);
            toast.error("Failed to get log");
        }
    });
    return (_jsx(CommentsAndLogsTabContent, { typeId: taskId, fetchData: fetchLogs, renderItem: (log) => _jsx(TabContentItem, { log: log }), noDataMessage: "No logs available", explanation: "Logs can be seen only by WordPress users (with required permissions)" }));
}
export { LogsTabContent };
